<template>
  <div id="PrintSessionView4">
    <div v-if="PrintSessionShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <div style="display: flex">
          <div style="margin-right: 10px">
            活動開始日期：<br />
            <flat-pickr
              v-model="queryInfo.sActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <div>
            活動結束日期：<br />
            <flat-pickr
              v-model="queryInfo.eActiveTime"
              :config="flatpickrConfig"
              ref="flatpickrInstance"
            ></flat-pickr>
          </div>

          <button
            href="#"
            @click.prevent="getALLSessionList7()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            查詢
          </button>
          <button
            href="#"
            @click.prevent="reset()"
            class="btn btn-outline-info"
            type="button"
            style="font-size: 14px"
          >
            清除重來
          </button>

          <a
            style="margin: 0 0.5rem; text-decoration: none"
            target="_blank"
            tabindex="4"
            class="ncut-excel-style"
            :href="
              './WebApi/HighSchoolEnrolling/GetSessionXLSX7/'
                .concat(queryInfo.sActiveTime)
                .concat('/')
                .concat(queryInfo.eActiveTime)
            "
            v-show="total > 0"
          >
            <img src="@/assets/images/ods-file24.png" style="height: 0.8rem" />
            {{ $t("message.Excel_txt") }}
          </a>
        </div>
        活動日期起迄：{{ sActiveTime + "-" + eActiveTime }}<br />
        目前招生活動宣導報名狀況合計共 {{ total }}筆
      </div>

      <b-tabs v-model="currentTab" content-class="mt-3" justified>
        <b-tab>
          <div
            class="dataTables_scrollBody"
            style="
              font-size: 14px;
              position: relative;
              overflow: auto;
              max-height: 100%;

              border-bottom: 1px solid #111;
              border-top: 1px solid #111;
            "
          >
            <b-table-simple
              title="queryInfo.options1Value"
              class="ncut-table-menu-striped ncut-table-menu"
              responsive
              bgcolor="#FFFFFF"
            >
              <b-thead class="ncut-thead-menu">
                <b-tr >
                  <b-th style="min-width: 2em">序號</b-th>
                  <b-th style="min-width: 2em">日期</b-th>
                  <b-th style="min-width: 2em">時間起迄</b-th>
                  <b-th style="min-width: 2em">活動名稱</b-th>
                  <b-th style="min-width: 2em">活動類型</b-th>
                  <b-th style="min-width: 2em">班數</b-th>
                  <b-th style="min-width: 2em">學生人數(DM數)</b-th>
                  <b-th style="min-width: 2em">宣導人數</b-th>
                  <b-th style="min-width: 2em">尚缺人數</b-th>
                </b-tr>
              </b-thead>
              <b-tbody class="ncut-tbody-menu">
                <b-tr v-for="(data, i) in filteredDocs" :key="i" :index="i">
                  <b-td style="text-align: center">
                    {{ i + 1 }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.sActiveTime }}
                  </b-td>

                  <b-td style="text-align: center">
                    {{ data.eActiveTime }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.activeName }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.typeName }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.classNumber }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.studentNumber }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.activeNumber }}
                  </b-td>
                  <b-td style="text-align: center">
                    {{ data.activeNumber - data.signUpTotal }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="pageSize"
              :limit="21"
              v-if="total > pageSize"
            />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";
export default {
  name: "PrintSessionView4",
  data() {
    return {
      currentTab: 0,
      sActiveTime: null,
      eActiveTime: null,
      ClassEnable: false,
      ForumEnable: false,
      ActiveName: null,
      selectedDateTime: null,
      TimeOpenShow: false,
      PrintSessionShow: false,
      options1Value: 1,
      options1: [{ value: 1, text: "個人查詢" }],
      cid: null,
      aid: null,
      sn: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected1: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      flatpickrConfig: {
        allowInput: true, // 允許手動輸入
        clear: true, // 顯示清除按鈕
        defaultDate: "2024-01-01", // 清除當前選擇的日期
        enableTime: false,
        weekNumbers: true,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "Y-m-d",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      inputData3: null,
      orglocalInputData3: null,
      localInputData3: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sActiveTime: null,
        eActiveTime: null,
        schoolName: null,
        dptcdName: null,
        gidName: null,
        updateUserName: null,
        options1Value: 1,
      },
    };
  },
  components: {
    flatPickr,
  },
  methods: {
    checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.queryInfo.sActiveTime)) {
        alert("請選擇活動開始日期");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.queryInfo.eActiveTime)) {
        alert("請選擇活動結束日期");
        this.inputFlag = true;
        return;
      }
    },
    getActiveTime() {
      let vm = this;
      if (tools.empty(vm.queryInfo.sActiveTime)) {
        vm.queryInfo.sActiveTime = vm.flatpickrConfig.default;
      }
      if (tools.empty(vm.queryInfo.eActiveTime)) {
        vm.queryInfo.eActiveTime = vm.flatpickrConfig.default;
      }

      if (!tools.empty(vm.queryInfo.sActiveTime)) {
        const dateObject = new Date(vm.queryInfo.sActiveTime);
        // 提取日期部分
        vm.queryInfo.sActiveTime = dateObject.toISOString().split("T")[0];
      }
      if (!tools.empty(vm.queryInfo.eActiveTime)) {
        const dateObject = new Date(vm.queryInfo.eActiveTime);
        // 提取日期部分
        vm.queryInfo.eActiveTime = dateObject.toISOString().split("T")[0];
      }
    },
    reset() {
      let vm = this;
      vm.queryInfo = {
        sActiveTime: null,
        eActiveTime: null,
      };
      vm.PrintSessionShow = true;

    },

    getALLSessionList7() {
      let vm = this;
      vm.checkInput();

      if (vm.inputFlag != true) {
        vm.sActiveTime = vm.queryInfo.sActiveTime;
        vm.eActiveTime = vm.queryInfo.eActiveTime;

        vm.getActiveTime();
        this.$http
          .put("./WebApi/HighSchoolEnrolling/GetALLSessionList7/", vm.queryInfo)
          .then((response) => {
            if (!tools.isNull(response)) {
              vm.inputData = response.data;
              vm.total = response.data.length;
              console.log("vm.inputData", vm.inputData);
            }
          })
          .catch(function (error) {
            alert("網路連線失敗" + error);
            // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
          });
      }
    },
  },
  computed: {

    filteredDocs: function () {
      let data = [];
      data = Array.isArray(this.inputData)
        ? this.inputData.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize
          )
        : [];
      return data;
    },


    headerColor() {
      return "#f7e8aa";
    },
  },

  created() {
    console.log("======created PrintSessionView4 =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.PrintSessionShow = true;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
